module.exports = __webpack_public_path__ + "a19ac5f8c369470f0ada1a861a155e8b.png";